import assetPath from '/opt/actions-runner/_work/crate/crate/packages/startpage-logged-out/native-apps-section/src/assets/app-store-badge-en.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')